import { render, staticRenderFns } from "./product-group-list.vue?vue&type=template&id=11948339&scoped=true&"
import script from "./product-group-list.vue?vue&type=script&lang=js&"
export * from "./product-group-list.vue?vue&type=script&lang=js&"
import style0 from "./product-group-list.vue?vue&type=style&index=0&id=11948339&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11948339",
  null
  
)

export default component.exports